import { createReducer, on } from "@ngrx/store";
import { InsurerDto } from "src/app/api/models";
import * as InsurerActions from "./insurer.actions";
import { resetInsurer} from './insurer.actions';

export const insurerFeatureKey = "insurer";

export interface InsurerState {
	insurerList: InsurerDto[] | undefined;

}
export const initialState: InsurerState = {
	insurerList: undefined,
	
};

export const insurerReducer = createReducer(
	initialState,
	on(InsurerActions.loadInsurerListSuccess, (state, { data }) => ({ ...state, insurerList: data })),
	on(InsurerActions.loadInsurerListFailure, (state, action) => ({ ...state, loadingInsurersError: action.error })),

	on(resetInsurer, () => initialState)

);
